import { FLOW_MODULE_DEFINITIONS } from "./flowEngineConfigHelper";

const processFromModuleId = (catalogmoduleId) => {
  const match = Object.entries(FLOW_MODULE_DEFINITIONS).find(
    ([, def]) => Number(def.moduleId) === Number(catalogmoduleId)
  );
  return match ? match[0] : "";
};

export const toFeederFlowRecord = (row, roleId) => {
  if (!row) {
    return null;
  }
  const process = String(row.module_key || row.process || processFromModuleId(row.catalogmodule_id) || "")
    .trim()
    .toLowerCase();
  const onFeeder = row.status === "draft";
  return {
    ...row,
    process,
    name: row.title || "",
    code: row.code || String(row.id || ""),
    subject_kind: "search_key_term",
    current_role_catalog_id: onFeeder ? Number(roleId || 0) : 0,
    deleted: Boolean(row.deleted)
  };
};
